import { NoteDef } from '../note/note.def';
import { ID } from '../typeDef';
import { ImagesLots } from '../Lots';
import { BOARD_NAME } from '../leaderboard/leaderboard';
import { TableDataTabContent } from '../../components/molecules/Nav/TableDataNav';

export interface FcTabOnglet {
  name: BOARD_NAME | string;
  title?: string;
  img?: ImagesLots;
}

export const maClasseTabs: TableDataTabContent[] = [
  { name: 'Ma Classe' },
  { name: 'Ventes' },
  { name: 'Challenge' },
  { name: 'Compétences' },
  { name: 'Quiz' },
  { name: 'Contrôle des commandes', variant: 'danger' }
];

interface QuizToNoteSuiviTab {
  quiz?: {
    id: ID;
  };
  createdAt?: string;
  note?: number;
}

export interface ElevesDashboard {
  id: ID;
  firstname: string;
  lastname: string;
  note?: NoteDef;
  mdp: string;
  shop: string;
  role?: string;
  unpayedCa?: number;
}

export interface ElevesDashboardProf extends ElevesDashboard {
  quiztonote: QuizToNoteSuiviTab[];
  orderNeedToBeReminded: number;
}
